export function getUrlWithoutProtocol(url: string) {
  const splitted = url.split('://');

  return splitted[splitted.length - 1];
}
